import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.tooltipEl = document.querySelector('#tooltip-element')
        this.boundHandleScroll = this.handleScroll.bind(this)
        window.addEventListener('scroll', this.boundHandleScroll, true)

    }

    handleScroll() {
        if (!this.tooltipEl || this.tooltipEl.classList.contains('hidden')) return;
        this.tooltipEl.style.opacity = '0';
        this.tooltipEl.classList.add('hidden')
        this.tooltipEl.innerHTML = ''
        this.tooltipEl.style.left = ''
        this.tooltipEl.style.top = ''
    }

    show(event) {
        if (!this.tooltipEl) return;
        const targetEl = event.currentTarget;
        let tooltipHtml = targetEl.dataset.tooltipContent;
        this.tooltipEl.innerHTML = tooltipHtml;

        this.tooltipEl.classList.remove("hidden");
        this.tooltipEl.style.opacity = '0';
        this.tooltipEl.style.left = ''
        this.tooltipEl.style.top = ''
        void this.tooltipEl.offsetWidth

        requestAnimationFrame(() => {
            const targetRect = targetEl.getBoundingClientRect();
            const tooltipRect = this.tooltipEl.getBoundingClientRect();

            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const offset = 8;
            const padding = 20;

            let finalLeft;
            let finalTop;

            // Helper function to check if a given rectangle is fully visible within the viewport padding
            const isPositionVisible = (left, top) => {
                return (
                    top >= padding &&
                    left >= padding &&
                    (top + tooltipRect.height) <= (viewportHeight - padding) &&
                    (left + tooltipRect.width) <= (viewportWidth - padding)
                );
            };

            // --- Define Potential Ideal Positions ---

            // Ideal horizontal position is always centered relative to the target
            const idealCenteredLeft = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2);

            // Position 1: Centered Below the target
            const posBelow = {
                top: targetRect.bottom + offset,
                left: idealCenteredLeft,
            };

            // Position 2: Centered Above the target
            const posAbove = {
                top: targetRect.top - tooltipRect.height - offset,
                left: idealCenteredLeft,
            };

            // --- Determine the Best Position based on Priority ---

            // PRIORITY 1: Try to place it "Centered Below"
            if (isPositionVisible(posBelow.left, posBelow.top)) {
                finalLeft = posBelow.left;
                finalTop = posBelow.top;
            }
            // PRIORITY 2: If that fails, try to place it "Centered Above"
            else if (isPositionVisible(posAbove.left, posAbove.top)) {
                finalLeft = posAbove.left;
                finalTop = posAbove.top;
            }
            // PRIORITY 3: If both ideal positions fail, fall back to the simple "clamp" logic
            else {
                // Clamp horizontal position
                finalLeft = Math.max(
                    padding,
                    Math.min(
                        idealCenteredLeft,
                        viewportWidth - tooltipRect.width - padding
                    )
                );

                // Clamp vertical position (defaulting to below and flipping if needed)
                finalTop = targetRect.bottom + offset;
                if (finalTop + tooltipRect.height > viewportHeight - padding) {
                    finalTop = targetRect.top - tooltipRect.height - offset;
                }
                if (finalTop < padding) {
                    finalTop = padding;
                }
            }

            // Apply the final calculated position and fade the tooltip in
            this.tooltipEl.style.left = `${finalLeft}px`;
            this.tooltipEl.style.top = `${finalTop}px`;
            this.tooltipEl.style.opacity = '1';
        });
    }

    hide() {
        // If the tooltip element doesn't exist or is already hidden, do nothing.
        if (!this.tooltipEl || this.tooltipEl.classList.contains('hidden')) return;
        this.tooltipEl.style.opacity = '0';
        this.tooltipEl.classList.add('hidden')
        this.tooltipEl.innerHTML = ''
        this.tooltipEl.style.left = ''
        this.tooltipEl.style.top = ''
    }

    disconnect() {
        window.removeEventListener('scroll', this.boundHandleScroll);
    }
}
